<template>
  <div>
    <div class="third-rea">
      <div class="third-btn">
        <div class="btn-left">检索条件</div>
        <div class="btn-right">
          <el-button class="btn-two" type="primary" @click="search()">查询</el-button>
          <el-button class="btn-two" type="default" @click="resetForm('formInline')">重置</el-button>
          <span class="btn-shu"></span>
          <el-button class="btn-four" type="default" icon="el-icon-search" @click="hignSearch">高级检索</el-button>
        </div>
      </div>
      <div class="third-search">
        <el-form :inline="true" :model="formInline" label-width="76px" ref="formInline">
          <div class="search-row">
            <div class="row-item">
              <el-form-item label="昵称" prop="nickname">
                <el-input
                  class="item-input"
                  :maxlength="30"
                  v-model.trim="formInline.nickname"
                  @keyup.enter.native="search"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
            <div class="row-item">
              <el-form-item label="账号" prop="account">
                <el-input
                  class="item-input"
                  :maxlength="30"
                  v-model.trim="formInline.account"
                  @keyup.enter.native="search"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
            <div class="row-item">
              <el-form-item label="姓名" prop="realname">
                <el-input
                  class="item-input"
                  :maxlength="30"
                  v-model.trim="formInline.realname"
                  @keyup.enter.native="search"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
            <div class="row-item">
              <el-form-item label="性别" prop="sex">
                <el-select class="item-input" v-model="formInline.sex" placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="男" value="1"></el-option>
                  <el-option label="女" value="2"></el-option>
                  <el-option label="无" value="3"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="row-item">
              <el-form-item label="角色" prop="roleId">
                <key-value-select
                  :className="'item-input'"
                  :isNeedAll="true"
                  v-model="formInline.roleId"
                  placeholder="请选择"
                  :dictProp="{
                    data: 'result',
                    label: 'roleName',
                    value: 'id',
                  }"
                  methods="post"
                  dictUrl="/api/blade-platform/platformalumniuser/roleList"
                ></key-value-select>
              </el-form-item>
            </div>
            <div class="row-item">
              <el-form-item label="是否禁言" prop="isForbidden">
                <el-select class="item-input" v-model="formInline.isForbidden" placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="0"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="third-one userManage">
      <div class="third-do-btn">
        <div class="do-btn-left">
          <el-button class="do-btn-two" type="default" icon="el-icon-turn-off-microphone" @click="FbdItem('select', 1)">禁言</el-button>
          <el-button
            class="do-btn-two"
            type="default"
            icon="el-icon-microphone"
            @click="FbdItem('select', 0)"
          >解除禁言</el-button>
        </div>
        <div class="do-btn-right">
          <div class="do-btn-check">
            <el-checkbox class="btn-check-item" v-model="checked" @change="changeHign"></el-checkbox>
            <span class="btn-check-span">显示高级功能</span>
          </div>
          <div class="do-btn-hign-list" v-if="checked">
            <!-- 展示字段 -->
            <sort-data
              :tableRow="tableRow"
              @showList="getTableList"
              sessionOriginalName="userManSortOrignalData"
              sessionResultName="userManSortData"
            ></sort-data>
            <!-- 数据顺序 -->
            <display-field
              :selectList="tableRow"
              sessionOriginalName="userManDisplayFiedOrignal"
              @setDataOrder="getDataOrder"
              sessionResultName="userManDisplayFied"
            ></display-field>
          </div>
        </div>
      </div>
      <el-table
        class="third-tableThree"
        :data="tableData"
        border
        stripe
        ref="tableData"
        @select="handleSelectChange"
        @select-all="handleSelectAll"
        :row-key="getRowKey"
        v-loading="loading"
      >
        <el-table-column type="selection" :reserve-selection="true" width="32px"></el-table-column>
        <template v-for="(item, index) in tableDataShow">
          <el-table-column
            min-width="100px"
            :prop="item.key"
            :label="item.column"
            :key="index"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              {{ getTextLabel(scope.row, item.key) }}
            </template>
          </el-table-column>
        </template>
        
        <el-table-column min-width="100px" prop="address" label="操作">
          <template slot-scope="scope">
            <el-button @click="forDetails(scope.row)" type="text" size="small">详情</el-button>
            <span style="height:100%">
              <span
                style="margin-left: 8px;margin-right: 8px;width: 1px;height: 12px;display: inline-block;background-color: #D4D4D7;vertical-align: middle;"
              ></span>
            </span>
            <el-button v-if="scope.row.isForbidden === 1" @click="FbdItem(scope.row, 0)" type="text" size="small">解除禁言</el-button>
            <el-button v-if="scope.row.isForbidden === 0" @click="FbdItem(scope.row, 1)" type="text" size="small">禁言</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="third-page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage4"
          background
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tot"
        ></el-pagination>
      </div>
    </div>
    <!-- <notice-modal
      :noticeModalVisible="noticeModal"
      @noticeModalClose="closeNotice"
      @noticeModalAgree="agreeNotice"
      :noticeTitle="noticeTitle"
      :noticeSpec="noticeSpec"
      :isError="isError"
      btnAgree="确认"
      :noticeContent="noitceContent"
    ></notice-modal> -->
    <!-- 高级搜索 -->
    <hign-modal
      :hignModalVisible="hignModal"
      @searchModal="toHignSearch"
      @cancelModal="closeModal"
      :hignOneList="tableRow"
    ></hign-modal>

    <el-dialog title="确认禁言" :visible.sync="shutupDialog" :before-close="dialogClose" class="shutupDialog" :close-on-click-modal="false" v-el-drag-dialog>
      <el-form :model="shutupForm" :rules="shutupRules" ref="shutupRuleForm" @validate="validateMethod" :show-message="false">
        <el-form-item label="禁言时间：" label-width="100px" prop="forbiddenTime">
          <el-radio-group v-model="shutupForm.forbiddenTime">
            <el-radio label="1">1天</el-radio>
            <el-radio label="3">3天</el-radio>
            <el-radio label="7">1周</el-radio>
            <el-radio label="30">1个月</el-radio>
            <el-radio label="99999">永久禁言</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="禁言原因：" label-width="100px" prop="reason">
          <el-input
            type="textarea"
            style="width: 300px;"
            :rows="4"
            placeholder="请输入内容"
            v-model="shutupForm.reason">
          </el-input>
          <div class="el-form-item__error">禁言后，该用户将不能在校友圈发布、评论、回复、转发动态</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelForm('shutupRuleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('shutupRuleForm')" v-el-disabel-repeat-click
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Sortable from "sortablejs";
import { getStore } from "@/utils/store";
// import { selectyuanxilist, delectyuanxi } from "@/api/baseData/yuanxi";
import keyValueSelect from "@/components/key-value/key-value-select";

export default {
  components: {
    keyValueSelect,
  },
  data() {
    return {
      loading:false,
      isIndeterminate: true,
      outputModal: false, // 导出弹窗
      isJS: true, //是否有检索条件
      rulesOutPut: {
        jbDesc: [{ required: true, message: "请输入", trigger: "blur" }]
      },
      ruleFormOutPut: {
        checkAll: false, // 全选
        jbDesc: "学生基础数据201908021223",
        fileList: [], // 文件列表
        gzRadio: "", // 重复规则
        fieldGroup: [] // 检查字段
      },
      detailModal: false, // 详情弹窗
      isError: true, // 是否是错误提示
      noticeSpec: "", // 标红提示
      noticeTitle: "确认操作", // 提示
      noitceContent: "是否确认删除？", // 提示信息
      noticeModal: false, // 提示弹窗
      delectID: "", //删除一条数据的ID
      countNum: 1, // 只显示第一条错误信息
      fieldArr: [
        {
          id: 1,
          label: "学号"
        },
        {
          id: 2,
          label: "姓名"
        },
        {
          id: 3,
          label: "专业"
        },
        {
          id: 4,
          label: "民族"
        },
        {
          id: 5,
          label: "班级"
        },
        {
          id: 6,
          label: "院系"
        },
        {
          id: 7,
          label: "本学期表现"
        },
        {
          id: 8,
          label: "学校"
        },
        {
          id: 9,
          label: "超过五个字的内容"
        },
        {
          id: 10,
          label: "这也是超过五个字的内容"
        }
      ],
      fieldsTableData: [
        {
          fields: "用户ID",
          isChecked: false
        },
        {
          fields: "姓名",
          isChecked: false
        },
        {
          fields: "学号",
          isChecked: false
        },
        {
          fields: "性别",
          isChecked: false
        },
        {
          fields: "民族",
          isChecked: false
        },
        {
          fields: "院系",
          isChecked: true
        },
        {
          fields: "专业",
          isChecked: false
        },
        {
          fields: "班级",
          isChecked: false
        },
        {
          fields: "部门",
          isChecked: false
        }
      ], // 字段显示数据
      fieldsModal: false, // 字段显示弹窗
      pageSize: 40,
      currentPage4: 1,
      tot: 0,
      tableData: [],
      hignModal: false, // 高级搜索
      formInline: {
        nickname: "",
        account: "",
        realname: "",
        sex: "",
        roleId: "",
        isForbidden: ""
      },
      checked: true,
      checkClassList: [],
      checkID:'',//表格选中的ID
      hignSearchRes: "", // 高级检索条件
      // 字段展示和顺序需要的参数
      orderConfig: "",
      tableRow: [
        {
          column: "账号",
          key: "account",
          needKeyValue: false,
          caseKey: "account"
        },
        {
          column: "姓名",
          key: "realName",
          needKeyValue: false,
          caseKey: "real_name"
        },
        {
          column: "昵称",
          key: "nickName",
          needKeyValue: false,
          caseKey: "nickname"
        },
        {
          column: "个性签名",
          key: "sign",
          needKeyValue: false,
          caseKey: "sign"
        },
        {
          column: "性别",
          key: "sex",
          needKeyValue: false,
          caseKey: "sex",
          isCustomList: [
              {
              label: '男',
              value: '1'
              },
              {
              label: '女',
              value: '2'
              }
          ]
        },
        {
          column: "身份",
          key: "identity",
          needKeyValue: false,
          caseKey: "identity",
          isCustomList: [
              {
              label: '学生',
              value: 'STUDENT'
              },
              {
              label: '教工',
              value: 'TEACHER'
              },
              {
              label: '其他',
              value: 'OTHER'
              }
          ]
        },
        {
          column: "角色",
          key: "roleName",
          needKeyValue: false,
          caseKey: "role_id"
        },
        {
          column: "是否禁言",
          key: "isForbidden",
          needKeyValue: false,
          caseKey: "is_forbidden",
          isCustomList: [
              {
              label: '正常',
              value: '0'
              },
              {
              label: '禁言',
              value: '1'
              }
          ]
        },
        {
          column: "动态数（条）",
          key: "dynamicNumber",
          needKeyValue: false,
          caseKey: "dynamicNumber"
        },
        {
          column: "被举报次数（次）",
          key: "reportNumber",
          needKeyValue: false,
          caseKey: "reportNumber"
        },
      ],
      tableDataShow: [
        {
          column: "账号",
          key: "account",
          needKeyValue: false,
          caseKey: "account"
        },
        {
          column: "姓名",
          key: "realName",
          needKeyValue: false,
          caseKey: "realName"
        },
        {
          column: "昵称",
          key: "nickName",
          needKeyValue: false,
          caseKey: "nickname"
        },
        {
          column: "个性签名",
          key: "sign",
          needKeyValue: false,
          caseKey: "sign"
        },
        {
          column: "性别",
          key: "sex",
          needKeyValue: false,
          caseKey: "sex"
        },
        {
          column: "身份",
          key: "identity",
          needKeyValue: false,
          caseKey: "identity"
        },
        {
          column: "角色",
          key: "roleName",
          needKeyValue: false,
          caseKey: "roleId"
        },
        {
          column: "是否禁言",
          key: "isForbidden",
          needKeyValue: false,
          caseKey: "isForbidden"
        },
        {
          column: "动态数（条）",
          key: "dynamicNumber",
          needKeyValue: false,
          caseKey: "dynamicNumber"
        },
        {
          column: "被举报次数（次）",
          key: "reportNumber",
          needKeyValue: false,
          caseKey: "reportNumber"
        },
      ],
      shutupForm: {
        forbiddenTime: '',
        reason: '',
      },
      forbiddenID: '', // 禁言id
      shutupDialog: false,
      shutupRules: {
        forbiddenTime: [
          { required: true, message: '请选择时间', trigger: 'change' }
        ],
        reason: [
          { required: true, message: '请输入原因', trigger: 'blur' }
        ],
      }
    };
  },
  created() {
    const dispField = this.getSessonValue("userManDisplayFied");
    const tableRow = this.getSessonValue("userManSortData");
    if (dispField) {
      this.orderConfig = dispField;
    }
    if (tableRow) {
      this.tableDataShow = tableRow;
    } else {
      this.tableDataShow = this.tableRow;
    }
    // console.log("字段", this.tableDataShow);
    this.selectList();
  },
  methods: {
    // 高级检索
    toHignSearch(res) {
      console.log(res);
      this.hignSearchRes = res;
      this.currentPage4 = 1;
      this.hignModal = false;
      this.selectList();
    },
    //获取列表
    selectList() {
      try {
        // console.log("看一看orderConfig", this.orderConfig);
        let dataSortStr = this.orderConfig;
        if (Array.isArray(this.orderConfig)) {
          // console.log(
          //   "看一看orderConfig的type",
          //   Array.isArray(this.orderConfig)
          // );
          dataSortStr = this.orderConfig.join(",");
        }
        const params = {
          nickname: this.formInline.nickname,
          account: this.formInline.account,
          realname: this.formInline.realname,
          sex: this.formInline.sex,
          roleId: this.formInline.roleId,
          isForbidden: this.formInline.isForbidden, //0.不禁言1.禁言
          pageIndex: this.currentPage4,
          pageSize: this.pageSize,
          dataSortStr: dataSortStr, //数据排序
          advancedSearch: this.hignSearchRes, // 高级检索
        };
        this.loading = true
        this.$store.dispatch(
          'platformalumniuserList',
          params
        ).then(res => {
          this.loading = false  
          const data = res.data;
          console.log("这是院系管理列表获取接口", data);
          if (data.status === 1000) {
            this.tableData = data.result.records;
            this.tot = data.result.total;
          } else {
            this.tableData = []
            this.tot = 0
          }
        });
      } catch (err) {
        this.loading = false  
        console.log(err);
      }
    },
    getTextLabel(row, key) {
      // console.log(row, key)
      let value = row[key];
      switch (key) {
        case 'sex':
          if (row[key] === 1) {
            value = '男';
          } else if (row[key] === 2) {
            value = '女';
          } else {
            value = '无';
          }
          break;
        case 'isForbidden':
          if (row[key] === 1) {
            value = '禁言';
          } else if (row[key] === 0) {
            value = '正常';
          }
          break;
        case 'identity':
          if (row[key] === 'STUDENT') {
            value = '学生';
          } else if (row[key] === 'GRADUATE_STUDENT') {
            value = '毕业生';
          } else if (row[key] === 'NEW_STUDENT') {
            value = '新生';
          } else if (row[key] === 'TEACHER') {
            value = '教工';
          } else if(row[key] === 'OTHER') {
            value = '其他';
          } else if(row[key] === 'SYSTEM'){
            value = '系统';
          } else {
            value = '异常账户';
          }
          break;
        default:
          value = row[key];
          break;
      }
      // console.log(value, 'label值')
      return value;
    },
    //查询详情
    forDetails(row) {
      console.log("这是row", row);
      sessionStorage.setItem('detailsUserID', row.userId);
      this.$emit("addYuanxi", '');
    },
    //保存选中状态
    getRowKey(row) {
      return row.userId;
    },
    //表格多选框选中
    handleSelectChange(selection) {
      // console.log(selection);
      this.checkClassList = [];
      for (var i = 0; i <= selection.length - 1; i++) {
        this.checkClassList.push(selection[i].userId);
      }
      this.checkID = this.checkClassList.join(',')
      // console.log("这是我选择的选项", this.checkClassList, this.checkID);
    },
    //表格全选中
    handleSelectAll(selection) {
      // console.log(selection);
      this.checkClassList = [];
      for (var i = 0; i <= selection.length - 1; i++) {
        this.checkClassList.push(selection[i].userId);
      }
      this.checkID = this.checkClassList.join(',')
      // console.log("这是我的选项", this.checkClassList);
    },
    // // 确认弹窗
    // agreeNotice() {
    //   console.log("确定弹窗", this.delectID);
    //   if (this.delectID !== "") {
    //     this.delect(this.delectID);
    //   } else {
    //     this.Alldelect();
    //   }
    //   this.noticeModal = false;
    // },
    // // 关闭弹窗
    // closeNotice() {
    //   // this.$refs.YXtableData.clearSelection();
    //   // this.checkClassList = [];
    //   this.delectID = "";
    //   this.noticeModal = false;
    // },
    // // 下一步
    // nextStep() {},
    // // 上移
    // moveUp(index, row) {
    //   const Vm = this;
    //   console.log("上移", index, row);
    //   if (index > 0) {
    //     Vm.originData = JSON.parse(JSON.stringify(Vm.fieldsTableData));
    //     let upDate = Vm.fieldsTableData[index - 1];
    //     Vm.fieldsTableData.splice(index - 1, 1);
    //     Vm.fieldsTableData.splice(index, 0, upDate);
    //   } else {
    //     Vm.$message.warning("已经是第一条，不可上移");
    //   }
    // },
    // moveDown(index, row) {
    //   const Vm = this;
    //   console.log("下移", index, row);
    //   if (index + 1 === Vm.fieldsTableData.length) {
    //     Vm.$message.warning("已经是最后一条，不可下移");
    //   } else {
    //     // console.log(index);
    //     Vm.originData = JSON.parse(JSON.stringify(Vm.fieldsTableData));
    //     let downDate = Vm.fieldsTableData[index + 1];
    //     Vm.fieldsTableData.splice(index + 1, 1);
    //     Vm.fieldsTableData.splice(index, 0, downDate);
    //   }
    // },
    // // 行拖拽
    // initSortabel() {
    //   const el = document.querySelector(".fields-table .el-table__body tbody");
    //   const Vm = this;
    //   console.log("el", el);
    //   Vm.sortable = new Sortable(el, {
    //     animation: 300,
    //     onEnd(evt) {
    //       // 拖拽结束发生该事件
    //       Vm.fieldsTableData.splice(
    //         evt.newIndex,
    //         0,
    //         Vm.fieldsTableData.splice(evt.oldIndex, 1)[0]
    //       );
    //       const newArray = Vm.fieldsTableData.slice(0);
    //       Vm.fieldsTableData = [];
    //       Vm.$nextTick(() => {
    //         Vm.fieldsTableData = newArray;
    //       });
    //     }
    //   });
    // },
    // 字段显示
    // showFields() {
    //   this.fieldsModal = true;
    //   this.$nextTick(() => {
    //     this.initSortabel();
    //   });
    // },
    // 关闭字段显示弹窗
    // closeFileds() {
    //   this.fieldsModal = false;
    // },
    // 显示高级或者不显示
    changeHign() {
      console.log(this.checked);
    },
    // 关闭弹窗
    closeModal() {
      this.hignModal = false;
    },
    // 高级检索
    hignSearch() {
      this.hignModal = true;
    },
    //条数变化
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage4 = 1;
      this.pageSize = val;
      this.selectList();
      this.pageChanageSelect();
    },
    //页码变化
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage4 = val;
      this.selectList();
      this.pageChanageSelect();
    },
    //页面变化时
    pageChanageSelect() {
      console.log("切换", this.checkClassList);
    },
    //查询
    search() {
      console.log(this.formInline);
      this.hignSearchRes = "";
      this.currentPage4 = 1;
      this.selectList();
    },
    getTableList(value) {
      this.tableDataShow = value;
    },
    getDataOrder(value) {
      this.orderConfig = value;
      console.log("改变了数据顺序", this.orderConfig);
      this.selectList();
    },
    getSessonValue(name) {
      return getStore({
        name: name,
        type: "session"
      });
    },
    //表单重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      Object.keys(this.formInline).forEach((key) => {
        this.formInline[key] = '';
      })
      this.search()
    },
    // 设置禁言
    FbdItem(row, type) {
      if (row === 'select') {
        if (this.checkClassList.length == 0) {
          this.$message.warning("请选择");
        } else {
          //解除禁言
          if (type === 0) {
            this.$confirm('是否确认解除禁言?', '确认操作', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              const params = {
                userId: this.checkID,
                isForbidden: 0,
                forbiddenTime: '',
                reason: '',
              }
              this.forbiddenMethods(params);
            }).catch(() => {});
          } else {
            this.forbiddenID = this.checkID;
            this.shutupDialog = true;
          }
        }
      } else {
        if (type === 0) {
          this.$confirm('是否确认解除禁言?', '确认操作', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const params = {
              userId: row.userId,
              isForbidden: 0,
              forbiddenTime: '',
              reason: '',
            }
            this.forbiddenMethods(params);
          }).catch(() => {});
        } else {
          this.forbiddenID = row.userId;
          this.shutupDialog = true;
        }
      }
    },
    // 提交禁言
    submitForm(formName) {
      this.countNum = 0;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.forbiddenID)
          const params = {
            userId: this.forbiddenID,
            isForbidden: 1,
            forbiddenTime: this.shutupForm.forbiddenTime,
            reason: this.shutupForm.reason,
          }
          this.forbiddenMethods(params);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 屏蔽方法
    forbiddenMethods({userId, isForbidden, forbiddenTime, reason}) {
      this.$store.dispatch('updateForbidden', {
        userId,
        isForbidden,
        forbiddenTime,
        reason,
      }).then((res) => {
        if (res.data.status === 1000) {
          this.shutupDialog = false;
          this.selectList();
          this.$refs['shutupRuleForm'].resetFields();
          this.$message({
            message: '操作成功!',
            type: 'success'
          });
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    cancelForm(formName) {
      this.$refs[formName].resetFields();
      this.shutupDialog = false;
      Object.keys(this.shutupForm).forEach((key) => {
        this.shutupForm[key] = '';
      })
    },
    validateMethod(prop, msgStatus, validateMessage) {
      // console.log(prop, msgStatus, validateMessage)
      if (!msgStatus && !this.countNum) {
          this.countNum += 1;
          if (validateMessage) {
              this.$message.error(validateMessage)
          }
      }
    },
    dialogClose(done) {
      this.$refs['shutupRuleForm'].resetFields();
      Object.keys(this.shutupForm).forEach((key) => {
        this.shutupForm[key] = '';
      })
      done();
    },
  }
};
</script>

<style lang="scss">
.third {
  .userManage {
    .third-tableThree {
      .el-table__body-wrapper {
        height: calc(100vh - 239px) !important;
      }
    }
  }
}
.shutupDialog {
  .el-dialog {
    width: 530px;
  }
  .el-radio {
    margin-right: 15px;
  }
}
.userManage {
  height: calc(100vh - 120px);
}
</style>
